<template>
  <div>

    <b-container fluid class="header noselect">
      <b-row>
        <!-- Menu -->
        <b-col cols="2" class="d-lg-none text-left" align-self="center">
          <p class="logout m-0" @click="showMenu = !showMenu">
            <icon scale="1" name="bars"></icon>
          </p>
        </b-col>
        <!-- Logo -->
        <b-col cols="8" lg="2">
          <img class="p-2 mb-1 rounded-bottom logo mx-auto d-block" src="../../assets/img/easytick_color.png">
        </b-col>
        <!-- Sair Mobile -->
        <b-col cols="2" align-self="center" class="py-1 d-lg-none text-right">
          <p class="logout m-0">
            <router-link :to="{ name: 'Logout' }">
              <icon scale="1" name="power-off"></icon>
            </router-link>
          </p>
        </b-col>


        <b-col cols="12" lg="8" align-self="center" class="my-2">
          <b-row class="text-center">
            <b-col cols="12">
              <h1 class="title m-0">
                Relatório
              </h1>
            </b-col>
          </b-row>
        </b-col>

        <!-- Sair Desktop -->
        <b-col lg="2" align-self="center" class="py-1 d-none d-lg-block text-right">
          <p class="logout m-0">
            <router-link :to="{ name: 'Logout' }">
              <icon scale="1" name="power-off"></icon>
            </router-link>
          </p>
        </b-col>

      </b-row>
    </b-container>

    <b-container fluid>
      <b-row>
        <b-col cols="12" lg="2" v-if="showMenu" class="mmenu noselect pt-4">

          <h1>Página Inicial</h1>
          <b-nav vertical class="mb-4 mt-1 rounded">
            <b-nav-item :to="{ name: 'OrganizerEvents' }">
              <icon scale="0.9" class="mr-1" name="arrow-left"></icon> Voltar
            </b-nav-item>
          </b-nav>

        </b-col>

        <b-col cols="12" lg="10" style="min-height: calc(100vh - 83px)" class="pt-3">
          <router-view/>
        </b-col>
      </b-row>
    </b-container>

    <b-container fluid class="footer">
      <b-row>
        <b-col>
          <p class="text-center my-2"><strong>Easytick</strong>, desde 2017 🎉</p>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: 'OrganizerGroupedReportDashboard',
  data () {
    return {
      showMenu: true,
    }
  },
  created () {

  },
  methods: {

  },
  computed: {

  }
}
</script>
